import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnInit,
    Renderer2,
    ViewChild,
    OnDestroy,
} from "@angular/core";
import { filter, takeUntil } from "rxjs/operators";
import { NavigationEnd, Router } from "@angular/router";
import * as objectPath from "object-path";
// Layout
import {
    LayoutConfigService,
    MenuAsideService,
    MenuOptions,
    OffcanvasOptions,
} from "../../../core/_base/layout";
import { HtmlClassService } from "../html-class.service";
import { SharedService } from "../../../../app/shared/sharedServices/shared.service";
import { decrypt, encrypt } from "../../../../app/utilities/utilityFunctions";
import { ForeignEmbassyValidatorService } from "../../pages/dashboard/services/foreign-embassy-validator.service";
import { Subscribable, Subscription } from "rxjs";
// import { AuthorizePersonService } from '../../pages/authorize-person/services/authorize-person.service';
import { HEC_CONSTANTS } from "../../../utilities/constants";
import { flatMap } from "lodash";
import { Subject } from "rxjs/internal/Subject";
import { PcdDataService } from "../../pages/pcd/pcd-data.service";

@Component({
    selector: "kt-aside-left",
    templateUrl: "./aside-left.component.html",
    styleUrls: ["./aside-left.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsideLeftComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild("asideMenu", { static: true }) asideMenu: ElementRef;
    private menuSubscription: Subscription;
    private readonly pcdAsideMenuNavigationKey = "pcd-from-aside-menu";

    currentRouteUrl = "";
    insideTm: any;
    outsideTm: any;
    role: string;
    category: string;
    public authorizeInterval: any;
    public view: Subscription;
    public isAuthorizePersonAvailable: boolean = false;
    private unsubscribe = new Subject<void>();
    public curentRole: string = ''
    public dasScrutinyMenuTitle: string = '';
    public dasScrutinyMenuRoute: string = '';
    menuCanvasOptions: OffcanvasOptions = {
        baseClass: "kt-aside",
        overlay: true,
        closeBy: "kt_aside_close_btn",
        toggleBy: {
            target: "kt_aside_mobile_toggler",
            state: "kt-header-mobile__toolbar-toggler--active",
        },
    };

    menuOptions: MenuOptions = {
        // vertical scroll
        scroll: null,

        // submenu setup
        submenu: {
            desktop: {
                // by default the menu mode set to accordion in desktop mode
                default: "dropdown",
                // whenever body has this class switch the menu mode to dropdown
                state: {
                    body: "kt-aside--minimize",
                    mode: "dropdown",
                },
            },
            tablet: "accordion", // menu set to accordion in tablet mode
            mobile: "accordion", // menu set to accordion in mobile mode
        },

        // accordion setup
        accordion: {
            expandAll: false, // allow having multiple expanded accordions in the menu
        },
    };
    controllerRole: any = null;
    adminRole: any = null;
    stampAdmin: any = null;
    /** `getSpRole`: `{ processAcronym: 'COURSERA', role: 'FOCAL_PERSON' }` */
    hasCourseraUniversityFocalPerson = false;
    /** `getSpRole`: `{ processAcronym: 'COURSERA', role: 'ADMIN' }` */
    hasCourseraHecAdmin = false;
    /** Process acronyms from authenticate `getSpRole` (e.g. DAS, COURSERA, DESF). */
    private readonly userProcessAcronyms = new Set<string>();

    /**
     * Declarative role → menu-item registry.
     * To wire a NEW getSpRole role to a side-menu item:
     *   1. Add one entry to this array.
     *   2. That's it — no other code changes needed.
     *
     * Fields:
     *   processAcronym  — matches getSpRole[].processAcronym
     *   role            — matches getSpRole[].role
     *   title           — optional label override; defaults to formatRoleLabel(role)
     *   route           — Angular router path for the menu item
     *   icon            — Font Awesome class string
     */
    private readonly spRoleMenuRegistry: ReadonlyArray<{
        processAcronym: string;
        role: string;
        title?: string;
        route: string;
        icon: string;
    }> = [
        { processAcronym: 'DAS', role: 'Das_Hec_Scrutiny_Officer', route: '/hec-scrutiny/dashboard',         icon: 'fas fa-search'        },
        { processAcronym: 'DAS', role: 'Das_Hec_Approver',          route: '/verification-officer/dashboard', icon: 'fas fa-check-circle'  },
        { processAcronym: 'DAS', role: 'Das_HEC_Approver',          route: '/verification-officer/dashboard', icon: 'fas fa-check-circle'  },
        { processAcronym: 'DAS', role: 'Das_Ufp_Scrutiny_Officer',  title: 'Das Ufp Verification Officer',    route: '/ufp/dashboard',      icon: 'fas fa-search'        },
        { processAcronym: 'DAS', role: 'Das_Ufp_Approver',          route: '/ufp/dashboard',                 icon: 'fas fa-check-circle'  },
        { processAcronym: 'DAS', role: 'hec_desf_equ_officer',      route: '/hec-desf-equ-officer/dashboard', icon: 'fas fa-search'        },
        { processAcronym: 'DAS', role: 'hec_des_equ_officer',      route: '/hec-des-equ-officer/dashboard', icon: 'fas fa-search'        },
    ];

    /**
     * Populated at login from `getSpRole`: one entry per registry-matched role the
     * user holds.  Each entry becomes an independent side-menu item.
     */
    private dasRoleMenuEntries: Array<{ title: string; route: string; icon: string }> = [];
    /** DAS getSpRole role values held by the logged-in user (e.g. Das_Hec_Scrutiny_Officer). */
    private dasSpRoles: Set<string> = new Set();

    private isDasMenuRole(): boolean {
        return this.role === 'DAS' || this.role === 'DAS-COURSERA';
    }

    private isCourseraMenuRole(): boolean {
        return (
            this.role === 'COURSERA' ||
            this.role === 'PCD-COURSERA' ||
            this.role === 'DAS-COURSERA'
        );
    }

    /** DAS Approved Blacklisted Applicants — only blacklist verification admins. */
    private canShowDasBlacklistedApplicantsMenu(): boolean {
        return this.category === 'DBV_ADMIN';
    }

    /** Attestation Education Correction — HEC Scrutiny Officer, HEC Approver, and education correction admin. */
    private canShowAttestationEducationCorrectionMenu(): boolean {
        return (
            this.dasSpRoles.has('Das_Hec_Scrutiny_Officer') ||
            this.dasSpRoles.has('Das_Hec_Approver') ||
            this.dasSpRoles.has('Das_HEC_Approver') ||
            this.dasSpRoles.has('hec_education_correction_admin')
        );
    }

    /**
     * Match a sidebar row to the logged-in process role.
     * Uses the full `userProcessAcronyms` set so every process the user holds
     * (DAS, DESF, DES, PCD, COURSERA …) can show its own menu items, even when
     * multiple processes are present in `getSpRole` simultaneously.
     */
    private menuItemMatchesUserProcess(element: { role?: string }): boolean {
        if (!element || !element.role) {
            return false;
        }
        return this.userHasProcess(element.role);
    }

    private userHasProcess(processAcronym: string): boolean {
        return this.userProcessAcronyms.has(processAcronym);
    }

    /**
     * ─── HOW TO ADD A BRAND-NEW PROCESS ACRONYM (e.g. "HRM") ───────────────────
     *
     * TOUCH-POINT 1 of 4 — add the new acronym string to this list.
     * This makes the system hide its menu rows for users who don't have that process.
     *
     *   const processes = ['DES', 'DESF', 'DAS', 'COURSERA', 'PCD', 'HRM'];
     *
     * ─────────────────────────────────────────────────────────────────────────────
     */
    private enforceProcessMenuOwnership(element: any): void {
        if (!element) {
            return;
        }
        const processes = ['DES', 'DESF', 'DAS', 'COURSERA', 'PCD'];
        for (let p = 0; p < processes.length; p++) {
            const proc = processes[p];
            if (!this.userHasProcess(proc)) {
                this.denyProcessMenuRow(element, proc);
            }
        }
    }

    private denyProcessMenuRow(element: any, processAcronym: string): void {
        if (!element) {
            return;
        }
        if (element.role === processAcronym) {
            element.allwoed = false;
        }
        if (element.submenu && element.submenu.length) {
            for (let i = 0; i < element.submenu.length; i++) {
                this.denyProcessMenuRow(element.submenu[i], processAcronym);
            }
        }
    }

    /**
     * True when `getSpRole` includes this menu row's process (or the row has no process role).
     *
     * ─── HOW TO ADD A BRAND-NEW PROCESS ACRONYM (e.g. "HRM") ───────────────────
     *
     * TOUCH-POINT 2 of 4 — add the new acronym to the if-condition below.
     * This makes the final-pass visibility check honour the new process.
     *
     *   element.role === 'DES' || ... || element.role === 'HRM'
     *
     * ─────────────────────────────────────────────────────────────────────────────
     */
    private userHasProcessForMenuElement(element: { role?: string }): boolean {
        if (!element || !element.role) {
            return true;
        }
        if (element.role === 'ALL') {
            return this.userHasProcess('DES') && this.userHasProcess('DESF');
        }
        if (
            element.role === 'DES' ||
            element.role === 'DESF' ||
            element.role === 'DAS' ||
            element.role === 'COURSERA' ||
            element.role === 'PCD'
        ) {
            return this.userHasProcess(element.role);
        }
        return true;
    }

    /** Last pass: hide DES/DESF/DAS/COURSERA/PCD rows not present in authenticate `getSpRole`. */
    private finalizeProcessMenuVisibility(): void {
        this.menuAsideService.menuList$.pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
            res.forEach((element) => {
                this.enforceProcessMenuOwnership(element);
                if (!this.userHasProcessForMenuElement(element)) {
                    element.allwoed = false;
                }
            });
            this.cdr.detectChanges();
        });
    }

    /**
     * Component Conctructor
     *
     * @param htmlClassService: HtmlClassService
     * @param menuAsideService
     * @param layoutConfigService: LayouConfigService
     * @param router: Router
    * @param render: Renderer2
     * @param cdr: ChangeDetectorRef
     */
    constructor(
        public htmlClassService: HtmlClassService,
        public menuAsideService: MenuAsideService,
        public layoutConfigService: LayoutConfigService,
        private router: Router,
        private render: Renderer2,
        private cdr: ChangeDetectorRef,
        private sharedService: SharedService,
        private pcdDataService: PcdDataService,
        private foreignValidator: ForeignEmbassyValidatorService // private authorizePersonService: AuthorizePersonService
    ) {
        if (localStorage.getItem("esp-profile-details")) {
            const profileDetails = JSON.parse(
                decrypt(localStorage.getItem("esp-profile-details"))
            );
            if (profileDetails) {
                console.log(profileDetails);
            }

        for (let i = 0; i < profileDetails.getSpRole.length; i++) {
            const processAcronym = profileDetails.getSpRole[i].processAcronym || profileDetails.getSpRole[i][0];
            const roleValue = profileDetails.getSpRole[i].role || profileDetails.getSpRole[i][1];
            if (processAcronym) {
                this.userProcessAcronyms.add(String(processAcronym));
            }
            if (processAcronym == 'DAS' && roleValue) {
                this.dasSpRoles.add(String(roleValue));
            }

            if (processAcronym == 'COURSERA') {
                this.curentRole = roleValue;
                if (roleValue === 'FOCAL_PERSON') {
                    this.hasCourseraUniversityFocalPerson = true;
                }
                if (roleValue === 'ADMIN') {
                    this.hasCourseraHecAdmin = true;
                }
            }
            if (
                processAcronym == "PCD" &&
                roleValue == "PCD_UNI_CONTROLLER"
            ) {
                this.controllerRole = roleValue;
            }
            if (
                processAcronym == "PCD" &&
                roleValue == "ADMIN"
            ) {
                this.adminRole = roleValue;
            }
            if (
                processAcronym == "DAS" &&
                roleValue == "Das_Stamp_Admin"
            ) {
                this.stampAdmin = roleValue;
                localStorage.setItem('spRole',this.stampAdmin)
            }
            if (
                processAcronym == "DAS" &&
                roleValue == "Das_Region_Admin"
            ) {
                this.stampAdmin = roleValue;
                localStorage.setItem('spRole',this.stampAdmin)
            }
            // Generic registry lookup — replaces all hardcoded DAS role if-blocks.
            // To add a new role: add one entry to spRoleMenuRegistry above.
            const spRoleMatch = this.spRoleMenuRegistry.find(
                m => m.processAcronym === processAcronym && m.role === roleValue
            );
            if (spRoleMatch) {
                this.dasRoleMenuEntries.push({
                    title: this.formatRoleLabel(spRoleMatch.title || roleValue),
                    route: spRoleMatch.route,
                    icon: spRoleMatch.icon
                });
            }
        }
            console.log(this.curentRole, '*****')
            this.role = this.sharedService.checkAdminType(profileDetails.getSpRole)
            this.category = this.sharedService.checkAdminCategory(profileDetails.getSpRole)
            console.log(this.sharedService.checkAdminRole(profileDetails.getSpRole));
            console.log(this.role, this.category)
            console.log(this.stampAdmin,'ss')
            if (this.role) {
                setTimeout(() => {
                    this.foreignOptions(true);
                }, 2000);
            }
             console.log(this.role,'roles')
             console.log(this.category,'category')
             console.log(this.controllerRole,'test role')

            // Generic multi-role menu: derive visibility from the full set of
            // processAcronyms returned by getSpRole, not a single collapsed role.
            // This means a user with e.g. { DAS: scrutiny } + { DESF: AD } will
            // see both the DAS and the DESF side-menus simultaneously.
            const hasDas      = this.userHasProcess('DAS');
            const hasDes      = this.userHasProcess('DES');
            const hasDesf     = this.userHasProcess('DESF');
            const hasPcd      = this.userHasProcess('PCD');
            const hasCoursera = this.userHasProcess('COURSERA');
            const hasAnyAdminProcess = hasDas || hasDes || hasDesf || hasPcd || hasCoursera;

            // DES / DESF menus (handles both when only one is present)
            if (hasDes || hasDesf) {
                this.applyDesDesfAsideMenus();
            }
            // 'ALL' items (role === 'ALL' in menu config) only appear when the
            // user has both DES and DESF — preserving the original ALL-role logic.
            if (hasDes && hasDesf) {
                this.applyAllAsideMenus();
            }
            // DAS menu (includes its own Coursera-row handling)
            if (hasDas) {
                // Inject one menu item per matched registry role BEFORE subscribing,
                // so applyDasAsideMenus sees the full list on its first emit.
                this.injectDasRoleMenuItems();
                this.applyDasAsideMenus();
            }
            // Coursera menu (runs for COURSERA-only, PCD-COURSERA or DAS-COURSERA)
            if (hasCoursera) {
                this.applyCourseraAsideMenus();
            }
            // PCD menu
            if (hasPcd) {
                this.applyPcdAsideMenus();
            }
            // ─── HOW TO ADD A BRAND-NEW PROCESS ACRONYM (e.g. "HRM") ─────────────
            //
            // TOUCH-POINT 3 of 4 — add a block here to call your new apply method.
            //
            //   const hasHrm = this.userHasProcess('HRM');
            //   if (hasHrm) { this.applyHrmAsideMenus(); }
            //
            // Also update hasAnyAdminProcess above to include `|| hasHrm`.
            // ─────────────────────────────────────────────────────────────────────
            // Regular user: no admin process present — disable all admin items
            if (!hasAnyAdminProcess) {
                this.applyUserAsideMenus();
            }

            setTimeout(() => this.finalizeProcessMenuVisibility(), 0);
    
    } else {
        this.router.navigate(["/auth/login"]);
    }
    }

    /**
     * Synchronously replaces the single `DSS` template entry in `menuList$` with
     * one real menu item per entry in `dasRoleMenuEntries`.
     *
     * Called with `getValue()` + `next()` (no subscription) so `applyDasAsideMenus`
     * sees the fully-expanded list on its first subscribe emit — no loop risk.
     *
     * To add a new side-menu item for a DAS role: add a row to `spRoleMenuRegistry`.
     */
    private injectDasRoleMenuItems(): void {
        if (!this.dasRoleMenuEntries.length) {
            return;
        }
        const current = this.menuAsideService.menuList$.getValue();
        const firstDssIndex = current.findIndex((item: any) => item.pageCode === 'DSS');
        if (firstDssIndex === -1) {
            return;
        }
        // Remove ALL existing DSS items (not just the first one) so that re-renders,
        // repeated next() calls, or component re-creation never accumulate duplicates.
        // Since firstDssIndex is the FIRST occurrence, all items before it are non-DSS,
        // so the insertion point in the filtered list is still firstDssIndex.
        const withoutDss = current.filter((item: any) => item.pageCode !== 'DSS');
        const injected = this.dasRoleMenuEntries.map(entry => ({
            title: entry.title,
            root: true,
            alignment: 'left',
            page: entry.route,
            icon: entry.icon,
            translate: entry.title,
            allwoed: false,
            pageCode: 'DSS',
            role: 'DAS'
        }));
        const updated = [
            ...withoutDss.slice(0, firstDssIndex),
            ...injected,
            ...withoutDss.slice(firstDssIndex)
        ];
        this.menuAsideService.menuList$.next(updated);
    }

    /** DES / DESF admin sidebar (unchanged behaviour; not used for DAS-only or DAS+Coursera users). */
    private applyDesDesfAsideMenus(): void {
                this.menuAsideService.menuList$.asObservable().pipe(takeUntil(this.unsubscribe)).subscribe(
                    (res) => {
                    res.forEach(element => {
                        this.enforceProcessMenuOwnership(element);
                        
                        if (element.role == 'PCD' && !this.userHasProcess('PCD')) {
                            element.allwoed = false;
                        }
                        if (element.role == 'COURSERA' && !this.userHasProcess('COURSERA')) {
                            element.allwoed = false;
                        }

                            if (
                                this.menuItemMatchesUserProcess(element) &&
                                this.userHasProcessForMenuElement(element) &&
                                element.pageCode !== 'STD' &&
                                element.pageCode !== 'DSS' &&
                                element.pageCode !== 'DEC'
                            ) {
                                    element.allwoed = true;
                                // if()
                                // {
                                //  element.allwoed = false;
                                //  this.cdr.detectChanges()
                                // }
                                //final letter for AD only
                                //  if(this.role =='DESF' && this.category == 'AD'){
                                //  element.submenu.forEach(subElement => {
                                //      //subElement.allwoed = true
                                //      if(subElement.pageCode == 'ADF'){
                                //          subElement.allwoed = true
                                //      }
                                //  });
                                // }

                                // else
                                if (this.category == 'AD' || this.category == 'DD' || this.category == 'DIR') {
                                if(element.submenu && element.submenu.length>0){
                                    element.submenu.forEach(subElement => {
                                        if (subElement) {
                                            // Use the full process set instead of this.role because
                                            // checkAdminType() can collapse DAS + DESF users to DAS.

                                            // new code
                                            const canShowDesfAdLetterMenus = this.userHasProcess('DESF') && this.category == 'AD';

                                            subElement.allwoed = true
                                            if (subElement.screenRole == 'GLOBAL' || subElement.screenRole == 'TA') {
                                                subElement.allwoed = true


                                            }
                                            else if (this.role == 'DES' && !(this.category == 'AD' || this.category == 'DD')) {
                                                if (subElement.pageCode == 'DFL') {
                                                    subElement.allwoed = false
                                                }
                                            }
                                            // old code
                                            // else if (this.role != 'DESF' || this.category != 'AD') {
                                            // new code
                                            else if (!canShowDesfAdLetterMenus) {
                                                if (subElement.pageCode == 'ADF') {
                                                    subElement.allwoed = false
                                                }
                                            }

                                            // old code
                                            // if (subElement.pageCode == 'STL' && !(this.role == 'DESF' && this.category == 'AD')) {
                                            // new code
                                            if (subElement.pageCode == 'STL' && !canShowDesfAdLetterMenus) {
                                                console.log(subElement.title)
                                                subElement.allwoed = false
                                            }
                                            //  console.log(subElement.title, subElement.allwoed)
                                        }
                                    });

                                }
                                }

                        else if (this.category == 'ASSISTANT' && this.role == 'DES') {
                            //console.log(this.role, this.category)
                            if (element.submenu) {
                                element.submenu.forEach(subElement => {
                                    if (subElement && (subElement.screenRole == 'TA' || subElement.pageCode == 'AV')) {
                                        subElement.allwoed = true
                                    }
                                });
                            }
                        } else if (this.category == 'ASSISTANT' && this.role == 'DESF') {
                            //console.log(this.role, this.category)
                            if (element.submenu) {
                                element.submenu.forEach(subElement => {
                                    if (subElement && subElement.pageCode == 'STL') {
                                        subElement.allwoed = true
                                    }
                                });
                            }
                        }
                else if (this.category == 'ADV') {
                    if (element.submenu) {
                        element.submenu.forEach(subElement => {
                            if (subElement) {
                                if (subElement.pageCode == 'AV') {
                                    subElement.allwoed = true
                                }
                                // Only disable DES/DESF submenu items, not DAS items
                                else if (element.role == 'DES' || element.role == 'DESF') {
                                    subElement.allwoed = false
                                }
                            }
                        });
                    }
                } else {
                    if (element.submenu) {
                        element.submenu.forEach(subElement => {
                            if (subElement && subElement.screenRole == 'TA') {
                                subElement.allwoed = true;
                            }
                        });
                    }
                }
            }
            if (element.screenRole == 'EAD' && (this.category == 'AD' || this.category == 'DD')) {
                element.allwoed = true;
            }
            this.enforceProcessMenuOwnership(element);
        });
        });
    }

    /** DAS and DAS + Coursera sidebar (does not run DES/DESF admin menu logic). */
    private applyDasAsideMenus(): void {
        this.menuAsideService.menuList$.asObservable().pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
            res.forEach(element => {
                this.enforceProcessMenuOwnership(element);

                // Only hide PCD items when the user does not hold the PCD process.
                // enforceProcessMenuOwnership already handles this, but we keep an
                // explicit guard here for the COURSERA sub-role edge case below.
                if (element.role == 'PCD' && !this.userHasProcess('PCD')) {
                    element.allwoed = false;
                }
                if (
                    element.role == 'COURSERA' &&
                    !this.hasCourseraUniversityFocalPerson &&
                    !this.hasCourseraHecAdmin
                ) {
                    element.allwoed = false;
                }

                if (element.pageCode === 'DSS') {
                    // Each DSS item was pre-configured by injectDasRoleMenuItems()
                    // (title, route, icon already set). Just enable it here.
                    element.allwoed = true;
                }

                if (
                    element.role === 'DAS' &&
                    element.pageCode === 'STD' &&
                    (this.stampAdmin === 'Das_Stamp_Admin' || this.stampAdmin === 'Das_Region_Admin')
                ) {
                    element.allwoed = true;
                    if (element.submenu && element.submenu.length > 0) {
                        if (this.stampAdmin === 'Das_Stamp_Admin') {
                            element.submenu.forEach(subElement => {
                                if (subElement && subElement.role == 'DAS') {
                                    if (subElement.pageCode === 'STG' || subElement.pageCode === 'STS') {
                                        subElement.allwoed = true;
                                    } else if (subElement.pageCode === 'STA') {
                                        subElement.allwoed = false;
                                    }
                                }
                            });
                        } else if (this.stampAdmin === 'Das_Region_Admin') {
                            element.submenu.forEach(subElement => {
                                if (subElement && subElement.role == 'DAS') {
                                    if (subElement.pageCode === 'STA') {
                                        subElement.allwoed = true;
                                    } else if (subElement.pageCode === 'STG' || subElement.pageCode === 'STS') {
                                        subElement.allwoed = false;
                                    }
                                }
                            });
                        }
                    }
                }

                if (
                    element.role === 'DAS' &&
                    this.userHasProcess('DAS') &&
                    element.pageCode !== 'STD' &&
                    element.pageCode !== 'DSS'
                ) {
                    if (element.pageCode === 'DABA') {
                        element.allwoed = this.canShowDasBlacklistedApplicantsMenu();
                    } else if (element.pageCode === 'DEC') {
                        element.allwoed = this.canShowAttestationEducationCorrectionMenu();
                    } else {
                        element.allwoed = true;
                    }
                }

                if (
                    (element.role === 'DES' || element.role === 'DESF') &&
                    !this.userHasProcessForMenuElement(element)
                ) {
                    element.allwoed = false;
                }

                this.enforceProcessMenuOwnership(element);
            });
        });
    }

    private applyAllAsideMenus(): void {
        this.menuAsideService.menuList$.asObservable().pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
            res.forEach(element => {
                this.enforceProcessMenuOwnership(element);
                if ((element.role == 'DAS' && !this.userHasProcess('DAS')) ||
                    (element.role == 'PCD' && !this.userHasProcess('PCD')) ||
                    (element.role == 'COURSERA' && !this.userHasProcess('COURSERA'))) {
                    element.allwoed = false;
                }
                if (element.role == 'ALL') {
                    element.allwoed = true;
                    if (this.category == 'AD' || this.category == 'DD' || this.category == 'DIR') {
                        if (element.submenu) {
                            element.submenu.forEach(subElement => {
                                if (subElement && (subElement.screenRole == 'GLOBAL' || subElement.screenRole == 'TA')) {
                                    subElement.allwoed = true;
                                }
                            });
                        }
                    } else if (this.category == 'ASSISTANT') {
                        if (element.submenu) {
                            element.submenu.forEach(subElement => {
                                if (subElement && (subElement.screenRole == 'TA' || subElement.pageCode == 'AV')) {
                                    subElement.allwoed = true;
                                }
                            });
                        }
                    } else if (this.category == 'ADV') {
                        if (element.submenu) {
                            element.submenu.forEach(subElement => {
                                if (subElement) {
                                    if (subElement.pageCode == 'AV') {
                                        subElement.allwoed = true;
                                    } else {
                                        subElement.allwoed = false;
                                    }
                                }
                            });
                        }
                    } else {
                        if (element.submenu) {
                            element.submenu.forEach(subElement => {
                                if (subElement && subElement.screenRole == 'TA') {
                                    subElement.allwoed = true;
                                }
                            });
                        }
                    }
                    this.cdr.detectChanges();
                }
            });
        });
    }

    private applyCourseraAsideMenus(): void {
        this.menuAsideService.menuList$.asObservable().pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
            res.forEach(element => {
                this.enforceProcessMenuOwnership(element);
                // Hide items for other processes the user does NOT hold.
                // enforceProcessMenuOwnership already handles this; these guards
                // are kept explicit for clarity and as a safety net.
                if (element.role === 'DAS' && !this.userHasProcess('DAS')) { element.allwoed = false; }
                if (element.role === 'DES' && !this.userHasProcess('DES')) { element.allwoed = false; }
                if (element.role === 'DESF' && !this.userHasProcess('DESF')) { element.allwoed = false; }
                if (element.role === 'PCD' && !this.userHasProcess('PCD')) { element.allwoed = false; }
                if (element.pageCode === 'ECA' && element.role === 'COURSERA') {
                    element.allwoed = false;
                    if (this.hasCourseraHecAdmin) {
                        element.title = 'HEC Focal Person';
                        element.translate = 'HEC Focal Person';
                        element.allwoed = true;
                    } else if (this.hasCourseraUniversityFocalPerson) {
                        element.title = 'University Focal Person';
                        element.translate = 'University Focal Person';
                        element.allwoed = true;
                    }
                    this.cdr.detectChanges();
                }
            });
        });
    }

    private applyPcdAsideMenus(): void {
        this.menuAsideService.menuList$.asObservable().pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
            res.forEach((element) => {
                this.enforceProcessMenuOwnership(element);
                // Only suppress other-process items when the user does NOT hold them.
                if (element.role == 'DAS' && !this.userHasProcess('DAS')) { element.allwoed = false; }
                if (element.role == 'DES' && !this.userHasProcess('DES')) { element.allwoed = false; }
                if (element.role == 'DESF' && !this.userHasProcess('DESF')) { element.allwoed = false; }
                if (element.pageCode == 'PCDA' && this.adminRole == 'ADMIN') {
                    element.allwoed = true;
                }
                if (this.controllerRole == 'PCD_UNI_CONTROLLER' && element.pageCode == 'PCDC') {
                    element.allwoed = true;
                }
            });
        });
    }

    // ─── HOW TO ADD A BRAND-NEW PROCESS ACRONYM (e.g. "HRM") ───────────────────
    //
    // TOUCH-POINT 4 of 4 — add a new apply method here (copy the PCD one as a template).
    //
    // private applyHrmAsideMenus(): void {
    //     this.menuAsideService.menuList$.asObservable().subscribe((res) => {
    //         res.forEach((element) => {
    //             this.enforceProcessMenuOwnership(element);
    //             if (element.role === 'HRM') {
    //                 element.allwoed = true;
    //                 // Add any role-specific submenu logic here
    //             }
    //         });
    //     });
    // }
    //
    // Also add the menu items in:  src/app/core/_config/menu.config.ts
    // (set role: 'HRM' on the new item, matching processAcronym from getSpRole).
    // ─────────────────────────────────────────────────────────────────────────────
    private applyUserAsideMenus(): void {
        this.menuAsideService.menuList$.asObservable().pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
            res.forEach(element => {
                this.enforceProcessMenuOwnership(element);
                if (
                    element.role == 'DAS' ||
                    element.role == 'DES' ||
                    element.role == 'DESF' ||
                    element.role == 'PCD' ||
                    element.role == 'COURSERA' ||
                    element.role == 'ALL'
                ) {
                    element.allwoed = false;
                }
            });
        });
    }

    ngAfterViewInit(): void {
        this.isFocalPerson();
    }

    ngOnDestroy(): void {
    

        if (this.role == 'DES' || this.role == 'DESF' || this.isDasMenuRole()) {
            this.menuAsideService.menuList$.asObservable().subscribe(
                (res) => {
                    res.forEach(element => {
                        if(element.role === 'DAS' &&  element.pageCode === 'STD' && (this.stampAdmin === "Das_Stamp_Admin" || this.stampAdmin === "Das_Region_Admin"))
                            {
                                element.allwoed = false;
                            }
                        
                    if (this.menuItemMatchesUserProcess(element)) {
                        element.allwoed = false;
                        if (this.category == 'AD' || this.category == 'DD' || this.category == 'ASSISTANT' || this.category == 'DIR') {
                            if (element.submenu) {
                                element.submenu.forEach(subElement => {
                                    if (subElement && (subElement.screenRole == 'GLOBAL' || subElement.screenRole == 'TA')) {
                                        subElement.allwoed = false
                                    }
                                });
                            }
                        } else if (this.category == 'ADV') {
                            if (element.submenu) {
                                element.submenu.forEach(subElement => {
                                    if (subElement && subElement.pageCode == 'AV') {
                                        subElement.allwoed = false
                                    }
                                });
                            }
                        }
                        else {
                            if (element.submenu) {
                                element.submenu.forEach(subElement => {
                                    if (subElement && subElement.screenRole == 'TA') {
                                        subElement.allwoed = false
                                    }
                                });
                            }
                        }
                            this.cdr.detectChanges()
                        }
                        else if (element.screenRole == "EAD" && (this.category == 'AD' || this.category == 'DD')) {
                            element.allwoed = false;
                            this.cdr.detectChanges()
                        }

                    });
                }
            )
        } else if (this.role == 'ALL') {
            this.menuAsideService.menuList$.asObservable().subscribe(
                (res) => {
                    res.forEach(element => {
                if (element.role == 'ALL') {
                    element.allwoed = false;
                    if (this.category == 'AD' || this.category == 'DD' || this.category == 'DIR') {
                        if (element.submenu) {
                            element.submenu.forEach(subElement => {
                                if (subElement && (subElement.screenRole == 'GLOBAL' || subElement.screenRole == 'TA')) {
                                    subElement.allwoed = false
                                }
                            });
                        }
                    } else if (this.category == 'ASSISTANT') {
                        if (element.submenu) {
                            element.submenu.forEach(subElement => {
                                if (subElement && (subElement.screenRole == 'TA' || subElement.pageCode == 'AV')) {
                                    subElement.allwoed = false
                                }
                            });
                        }
                    } else if (this.category == 'ADV') {
                        if (element.submenu) {
                            element.submenu.forEach(subElement => {
                                if (subElement && subElement.pageCode == 'AV') {
                                    subElement.allwoed = false
                                }
                            });
                        }
                    }
                    else {
                        if (element.submenu) {
                            element.submenu.forEach(subElement => {
                                if (subElement && subElement.screenRole == 'TA') {
                                    subElement.allwoed = false
                                }
                            });
                        }
                    }
                            this.cdr.detectChanges()
                        }

                    });
                }
            )
        }

        if (this.isDasMenuRole()) {
            this.menuAsideService.menuList$.asObservable().subscribe(
                (res) => {
                    res.forEach(element => {
                        if (element.pageCode == 'TCS') {
                            element.allwoed = false;
                            this.cdr.detectChanges()
                        }
                        // else if(element.pageCode == 'STD')
                        //  {
                        //      element.allwoed = true;
                        //      this.cdr.detectChanges()
                        //  }
                    });
                }
            )
        }


        if (this.role == "COURSERA") {
            this.menuAsideService.menuList$.asObservable().subscribe((res) => {
                res.forEach((element) => {
                    if (element.role == this.role) {
                        element.allwoed = false;
                        this.cdr.detectChanges();
                    }
                });
            });
        }
        if (this.role == "PCD") {
            this.menuAsideService.menuList$.asObservable().subscribe((res) => {
                res.forEach((element) => {
                    if (element.role == this.role) {
                        element.allwoed = false;
                    }
                });
            });
        }

        // if(this.role == 'ADMIN'){
        //  this.menuAsideService.menuList$.asObservable().subscribe(
        //      (res)=>{
        //          res.forEach(element => {
        //              if(element.pageCode == 'AR'){
        //                  element.allwoed = false;
        //                  this.cdr.detectChanges()
        //              }
        //          });
        //      }
        //  )
        //  this.menuAsideService.menuList$.asObservable().subscribe(
        //      (res)=>{
        //          res.forEach(element => {
        //              if( element.pageCode == 'AV'){
        //                  element.allwoed = false;
        //                  this.cdr.detectChanges()
        //              }
        //          });
        //      }
        //  )
        //  this.menuAsideService.menuList$.asObservable().subscribe(
        //      (res)=>{
        //          res.forEach(element => {
        //              if(element.pageCode == 'AD'){
        //                  element.allwoed = false;
        //                  this.cdr.detectChanges()
        //              }
        //          });
        //      }
        //  )
        // }
        // if(this.isAuthorizePersonAvailable){
        //  this.menuAsideService.menuList$.asObservable().subscribe(
        //      (res)=>{
        //          res.forEach(element => {
        //              if(element.pageCode == 'UA'){
        //                  element.allwoed = false;
        //                  this.cdr.detectChanges()
        //              }
        //          });
        //      }
        //  )
        // }

        // this.menuAsideService.menuList$.complete();
        this.role = undefined;
        this.foreignOptions(false);
        this.foreignValidator.sendForeign(false);
        localStorage.removeItem("isForeign");
        this.unsubscribe.next();
        this.role = undefined;
        if (this.authorizeInterval) {
            clearInterval(this.authorizeInterval);
        }
    }


    isFocalPerson() {
        this.sharedService.isFocalPerson().subscribe(
            (res) => {
                if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK && res.data) {
                    this.foreignValidator.sendForeign(true);
                } else {
                    this.foreignValidator.sendForeign(false);
                }
            },
            (err) => {
            }
        )


    }

    ngOnInit() {
        
        this.currentRouteUrl = this.router.url.split(/[?#]/)[0];

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => {
                this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
                this.cdr.markForCheck();
            });

        const config = this.layoutConfigService.getConfig();

        if (
            objectPath.get(config, "aside.menu.dropdown") !== true &&
            objectPath.get(config, "aside.self.fixed")
        ) {
            this.render.setAttribute(
                this.asideMenu.nativeElement,
                "data-ktmenu-scroll",
                "1"
            );
        }

        if (objectPath.get(config, "aside.menu.dropdown")) {
            this.render.setAttribute(
                this.asideMenu.nativeElement,
                "data-ktmenu-dropdown",
                "1"
            );
            // tslint:disable-next-line:max-line-length
            this.render.setAttribute(
                this.asideMenu.nativeElement,
                "data-ktmenu-dropdown-timeout",
                objectPath.get(
                    config,
                    "aside.menu.submenu.dropdown.hover-timeout"
                )
            );
        }

        setTimeout(() => {
            // this.getAuthoirizedPersonDetail();
        }, 2000)
    }

    /**
     * Check Menu is active
     * @param item: any
     */
    isMenuItemIsActive(item): boolean {
        if (item.submenu) {
            return this.isMenuRootItemIsActive(item);
        }

        if (!item.page) {
            return false;
        }

        return this.currentRouteUrl.indexOf(item.page) !== -1;
    }

    /**
     * Check Menu Root Item is active
     * @param item: any
     */
    isMenuRootItemIsActive(item): boolean {
        let result = false;

        for (const subItem of item.submenu) {
            result = this.isMenuItemIsActive(subItem);
            if (result) {
                return true;
            }
        }

        return false;
    }

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     * @param e Event
     */
    mouseEnter(e: Event) {
        // check if the left aside menu is fixed
        if (document.body.classList.contains("kt-aside--fixed")) {
            if (this.outsideTm) {
                clearTimeout(this.outsideTm);
                this.outsideTm = null;
            }

            this.insideTm = setTimeout(() => {
                // if the left aside menu is minimized
                if (
                    document.body.classList.contains("kt-aside--minimize") &&
                    KTUtil.isInResponsiveRange("desktop")
                ) {
                    // show the left aside menu
                    this.render.removeClass(
                        document.body,
                        "kt-aside--minimize"
                    );
                    this.render.addClass(
                        document.body,
                        "kt-aside--minimize-hover"
                    );
                }
            }, 50);
        }
    }

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     * @param e Event
     */
    mouseLeave(e: Event) {
        if (document.body.classList.contains("kt-aside--fixed")) {
            if (this.insideTm) {
                clearTimeout(this.insideTm);
                this.insideTm = null;
            }

            this.outsideTm = setTimeout(() => {
                // if the left aside menu is expand
                if (
                    document.body.classList.contains(
                        "kt-aside--minimize-hover"
                    ) &&
                    KTUtil.isInResponsiveRange("desktop")
                ) {
                    // hide back the left aside menu
                    this.render.removeClass(
                        document.body,
                        "kt-aside--minimize-hover"
                    );
                    this.render.addClass(document.body, "kt-aside--minimize");
                }
            }, 100);
        }
    }

    /**
     * Returns Submenu CSS Class Name
     * @param item: any
     */
    getItemCssClasses(item) {
        let classes = "kt-menu__item";

        if (objectPath.get(item, "submenu")) {
            classes += " kt-menu__item--submenu";
        }

        if (!item.submenu && this.isMenuItemIsActive(item)) {
            classes += " kt-menu__item--active kt-menu__item--here";
        }

        if (item.submenu && this.isMenuItemIsActive(item)) {
            classes += " kt-menu__item--open kt-menu__item--here";
        }

        // custom class for menu item
        const customClass = objectPath.get(item, "custom-class");
        if (customClass) {
            classes += " " + customClass;
        }

        if (objectPath.get(item, "icon-only")) {
            classes += " kt-menu__item--icon-only";
        }

        return classes;
    }

    getItemAttrSubmenuToggle(item) {
        let toggle = "hover";
        if (objectPath.get(item, "toggle") === "click") {
            toggle = "click";
        } else if (objectPath.get(item, "submenu.type") === "tabs") {
            toggle = "tabs";
        } else {
            // submenu toggle default to 'hover'
        }

        return toggle;
    }

    shouldHandleMenuNavigation(item: any): boolean {
        if (!item || !item.page) {
            return true;
        }

        const isPcdMenuItem = item.page === "/pcd" && item.pageCode === "PCD";
        const isAlreadyOnPcdPage =
            this.currentRouteUrl === "/pcd" || this.currentRouteUrl === "/pcd/";

        return !(isPcdMenuItem && isAlreadyOnPcdPage);
    }

    handleMenuNavigation(item: any): void {
        sessionStorage.removeItem(this.pcdAsideMenuNavigationKey);
        sessionStorage.removeItem("callPUTApplicationDegreeDetails");
        this.pcdDataService.clearStorage();

        if (!item || !item.page) {
            return;
        }

        if (item.page === "/pcd" && item.pageCode === "PCD") {
            sessionStorage.setItem(this.pcdAsideMenuNavigationKey, "true");
            sessionStorage.setItem("callPUTApplicationDegreeDetails", "false");
            return;
        }

        sessionStorage.removeItem(this.pcdAsideMenuNavigationKey);
    }

    // public async getAuthoirizedPersonDetail() {
    //  await this.authorizePersonService.getAuthorizePersonDetail().subscribe(
    //      (res) => {
    //          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
    //              if (!res.data.applicationId) {
    //                  this.isAuthorizePersonAvailable = false;
    //              } else if (res.data.applicationId) {
    //                  this.isAuthorizePersonAvailable = true;
    //                  if (this.isAuthorizePersonAvailable) {
    //                      this.menuAsideService.menuList$.asObservable().subscribe(
    //                          (res) => {
    //                              res.forEach(element => {
    //                                  if (element.pageCode == 'UA') {
    //                                      element.allwoed = true;
    //                                      this.cdr.detectChanges()
    //                                  }
    //                              });
    //                          }
    //                      )
    //                  }
    //              }
    //          } else if (res.statusCode == 4) {
    //              this.isAuthorizePersonAvailable = false;
    //          }
    //          else {
    //              this.isAuthorizePersonAvailable = false;
    //          }
    //      },
    //      (err) => {
    //          this.isAuthorizePersonAvailable = false;
    //      }
    //  )
    // }

    public foreignOptions(value: boolean): void {
        this.foreignValidator.getForeign().subscribe(
            (res) => {
                // this.view = res.isForeign;
                if (res && (res.isForeign || (res.isForeign == null && JSON.parse(decrypt(localStorage.getItem('isForeign')))))) {
                    this.menuAsideService.menuList$.asObservable()
                        .pipe(
                            takeUntil(this.unsubscribe)
                        )
                        .subscribe(
                            (res) => {
                                res.forEach(element => {
                                    if (element.pageCode == 'FE') {
                                        localStorage.setItem('isForeign', encrypt(value))
                                        element.allwoed = value;
                                        this.cdr.detectChanges()
                                    }
                                });

                            });
                }
            });
    }

    private formatRoleLabel(roleValue: string): string {
        const value = roleValue ? String(roleValue) : '';
        return value
            .replace(/_/g, ' ')
            .replace(/\bDas\b/g, 'DAS')
            .replace(/\bUfp\b/g, 'UFP')
            .replace(/\bhec\b/gi, 'HEC')
            .trim();
    }
}